import SpriteAnimation from '../common/SpriteAnimation';
import keyWatcher from '../common/keyWatcher';
import mouseWatcher from '../common/mouseWatcher';
import Entity from './Entity';
import config from '../common/config';

const gunOffsetY = 3;

function Player(maxX, gunImg, ...args) {
    Entity.apply(this, args);
    this.width = config.playerWidth;
    this.height = config.playerHeight;
    this.speed = config.speed * config.playerSpeed;
    this.animationSpeed = config.playerAnimationSpeed * config.speed;
    this.runAnimation = new SpriteAnimation(this);
    this.jumpAnimation = new SpriteAnimation({...this, ...{frameSequence: [6]}});
    this.fallAnimation = new SpriteAnimation({...this, ...{frameSequence: [7]}});
    this.gravity = config.gravity;
    this.isJump = false;
    this.animation = this.runAnimation;
    this._jumpCounter = 0;
    this._jumpDy = - (config.playerJumpCount + this.gravity);
    this.gunImg = gunImg;
    this.maxX = maxX;
    this.gun = {
        angle: 0, 
        width: gunImg.width, 
        height: gunImg.height,
        x: this.x + this.width - gunImg.width,
        y: this.y + gunImg.height + gunOffsetY,
    };
}

function getGunSprite() {
    const spriteObj = {
        angle: this.gun.angle,
        dx: this.gun.x,
        dy: this.gun.y,
        image: this.gunImg,
        dWidth: this.gun.width,
        dHeight: this.gun.height,
    };
    return spriteObj;
}

function getSprite() {
    const spriteObj = {
        dx: this.x,
        dy: this.y,
        image: this.image,
    };
    return {...spriteObj, ...this.animation.getFrame()};
}

function move() {
    this.x += this.dx * config.speed / 3;
    this.y += this.dy;
};

function update() {
    this.dx = 0;
    this.animationSpeed = config.playerAnimationSpeed * config.speed / 3;
    if (keyWatcher.isDown('D') && this.x < this.maxX - this.width) {
        this.dx = config.playerMovingSpeed;
        this.animationSpeed = this.animationSpeed * 3;
    }
    if (keyWatcher.isDown('A') && this.x > 0) {
        this.dx = -config.playerMovingSpeed;
        this.animationSpeed = -this.animationSpeed;
    }
    if (keyWatcher.isDown('SPACE') && this.dy === 0 && !this.isJump) {
        this.isJump = true;
        this.dy = this._jumpDy;
        this._jumpCounter = config.playerJumpCount;
    }
    if (keyWatcher.isDown('SPACE') && this._jumpCounter) {
        this.dy = this._jumpDy;
    }

    this._jumpCounter = Math.max(this._jumpCounter - 1, 0);
    this.move();

    if (this.isJump) {
        this.dy += this.gravity;
    }

    if (this.dy > 0) {
        this.animation = this.fallAnimation;
    } else if (this.dy < 0) {
        this.animation = this.jumpAnimation;
    } else {
        this.animation = this.runAnimation;
    }

    updateGun.call(this);
    this.animation.nextFrame(this.animationSpeed);
}

function updateGun () {
    this.gun.x = this.x + this.width - this.gunImg.width;
    this.gun.y = this.y + this.gunImg.height + gunOffsetY;
    let x = this.gun.x + this.gun.width / 2;
    let y = this.gun.y + this.gun.height / 2;

    this.gun.angle = Math.atan2(mouseWatcher.getPosY - y, mouseWatcher.getPosX - x);
}

Player.prototype = Object.create(Entity.prototype);
Player.prototype.constructor = Player;

Player.prototype.move = move;
Player.prototype.update = update;
Player.prototype.getSprite = getSprite;
Player.prototype.getGunSprite = getGunSprite;

export default Player;
